export enum BoundsEdgeIndexes {
    START = 0,
    END = 1,
};